<template>
  <v-select
    v-if="potentiality.length"
    v-model="selected_potentiality"
    :items="potentiality"
    :class="['contact-v-select', potentialityClass]"
    @update:modelValue="updatePotentiality"
    variant="outlined"
    no-details
    :disabled="!hasWritePermission"
  >
    <template #item="{ item }">
      <v-list-item @click="setValue(item)" style="padding: 0;">
        <div :style="getPotentialityStyle(item)" class="w-100 pa-2 text-center">
          {{ item.title }}
        </div>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
import apiClient from "@/core/buildRequest";
import { useAccountsStore } from "@/store/crm/useAccountsStore";
import { loginForm } from "@/store/logIn";

export default {
  name: "PotentialityCol",
  props: ["item", "id"],
  data() {
    return {
      selected_potentiality: "",
      potentiality: ["VIP", "A", "B", "C"],
      loginStore: loginForm(),
    };
  },
  mounted() {
    this.selected_potentiality = this.item?.potentiality || "";
  },
  computed: {
    potentialityClass() {
      switch (this.selected_potentiality) {
        case "VIP":
          return "contact-v-select-prime";
        case "A":
          return "contact-v-select-blue";
        case "B":
          return "contact-v-select-orange";
        case "C":
          return "contact-v-select-red";
        default:
          return "";
      }
    },
    hasWritePermission() {
      return this.loginStore?.permissions?.some((p) =>
        [
          "leads-managment.update",
          "leads-managment.create",
          "leads-managment.delete",
        ].includes(p)
      );
    },
  },
  watch: {
    "item.potentiality"(newVal) {
      this.selected_potentiality = newVal;
    },
  },
  methods: {
    async updatePotentiality() {
      if (!this.hasWritePermission) return;

      try {
        await apiClient.post(
          `/leads-managment/accounts/potentiality/${this.id}`,
          {
            potentiality: this.selected_potentiality,
          }
        );
        const account_store = useAccountsStore();
        account_store?.updatePotentiality(this.id, this.selected_potentiality);
      } catch (error) {
        console.error("Error updating potentiality:", error);
      }
    },
    setValue(item) {
      this.selected_potentiality = item.raw;
      this.updatePotentiality();
    },
    getPotentialityStyle(item) {
      const value = typeof item === "string" ? item : item?.raw || item?.title;

      const styles = {
        VIP: { color: "#1c6572", background: "#e9f8fc" },
        A: { color: "#0464bc", background: "#f5fafe" },
        B: { color: "#c14a05", background: "#fefbf1" },
        C: { color: "#d91313", background: "#fef3f2" },
      };

      return {
        ...(styles[value] ?? {}),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "600",
      };
    },
    HavePermission(p) {
      return this.loginStore?.permissions?.includes(p) || false;
    },
  },
};
</script>
